import LanguageIcon from "@/assets/colorable/language.svg?react";
import clsxm from "@/lib/clsxm";
import {LANGUAGE_OPTIONS} from "@/store/constants";
import type {TLanguage} from "@/store/types";
import {type FC} from "react";
import {useTranslation} from "react-i18next";
import {Tooltip} from "react-tooltip";

const LanguageSelector: FC<{
  value?: TLanguage;
  onChange: (language: TLanguage) => void;
  isDisabled?: boolean;
  iconClassName?: string;
}> = ({value, onChange, isDisabled, iconClassName}) => {
  const {t} = useTranslation();

  return (
    <div className="flex items-center gap-1.5">
      <LanguageIcon
        data-tooltip-id="language-selector"
        className={clsxm("text-primary-dark-solid size-4 shrink-0 cursor-pointer", iconClassName)}
      />
      <Tooltip
        id="language-selector"
        openOnClick
        clickable
        variant="light"
        place="bottom"
        opacity={1}
        className="z-100 p-0 shadow-md"
        classNameArrow="shadow-md">
        <div className="flex flex-col divide-y-1">
          {LANGUAGE_OPTIONS.map(language => (
            <button
              key={language.code}
              disabled={isDisabled}
              onClick={() => {
                if (value !== language.code) {
                  onChange(language.code);
                }
              }}
              className={clsxm(
                "disabled:bg-neutral-white-dark disabled:text-neutral-black flex min-h-16 flex-col items-center justify-center gap-0.5 bg-white px-8 transition-all duration-150 disabled:cursor-not-allowed disabled:border-none",
                value === language.code ? "text-primary-dark-solid" : "text-neutral-black hover:text-neutral-black/80",
              )}>
              <span className="font-medium">{t(language.name)}</span>
            </button>
          ))}
        </div>
      </Tooltip>
    </div>
  );
};

export default LanguageSelector;
